/**
 * @author mi
 * @date 2019/4/16
 * @project xingzhiyuan_2019
 */
export const defaultCfg = {
  zIndex: 1019,
  type: 'msg', // msg, alert, confirm, custom
  title: '',
  message: '',
  align: 'tc',
  icon: '',
  width: 'auto',
  contentPadding: true,
  showClose: true,
  shadeClose: false,
  callbackClose: false, // 回调函数关闭弹框
  showConfirmButton: false,
  showCancelButton: false,
  confirmButtonText: '确定',
  cancelButtonText: '取消',
  confirmButtonClass: 'btn-primary',
  cancelButtonClass: 'btn-second',
  appendToBody: true
}

// 弹框类型配置
export const typeCfg = {
  msg: {
    showCancelButton: false,
    showConfirmButton: false
  },
  alert: {
    showCancelButton: false,
    showConfirmButton: true
  },
  confirm: {
    showCancelButton: true,
    showConfirmButton: true
  },
  custom: {}
}
